import { get, set } from 'core-components/classes/services/StorageHelper'

import { IColumn } from '../types'

export const getColumnsFromStorage = (storageKey?: string): IColumn[] | undefined => {
  const savedColumns = get(`_table_columns--${storageKey}`)
  return savedColumns ? JSON.parse(savedColumns) : undefined
}

export const setColumnsToStorage = (storageKey: string | undefined, columns: IColumn[]) => {
  if (storageKey) {
    set(`_table_columns--${storageKey}`, JSON.stringify(columns))
  }
}
